module.exports = __webpack_public_path__ + "img/floating-indentation.569e6390.svg";